// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"pricing","420":"aiModel","472":"settings","548":"paymentSuccess","775":"paymentError","884":"admin","962":"home"}[chunkId] + "." + {"47":"7873262d","420":"2cdd8b0d","472":"9a3ad638","548":"12d6b5e1","775":"4a9926d9","884":"c4d44d93","962":"8c4d18d9"}[chunkId] + ".css";
};